import {
    Flex,
    useToast,
    Spinner,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import StreakFormEdit from "./formEdit";

const ModalEdit = ({ isOpen, onClose, selectedItem, refresh }: { isOpen: boolean, onClose: () => void, selectedItem: {}, refresh: () => void }) => {

    const closeModal = () => {
        refresh()
        onClose()
    }

    return (

        <Modal isOpen={isOpen} onClose={closeModal} isCentered size='xl'>
            <ModalContent mx='5' bgColor='black'>
                <ModalCloseButton color={'white'} />
                <ModalBody py='8'>
                    <Flex flexDirection={'column'} justifyContent='center' alignItems={'center'} gap='10px'>
                        <StreakFormEdit id={selectedItem?.id} />
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
};

export default ModalEdit;
